export default __webpack_public_path__ + "static/media/goshen60.498d6940.jpg";